<script>
	import { format } from 'svelte-i18n';
	import { Text } from '@Shelly/shelly-design-system';
</script>

<div class="d-flex align-items-center">
	<img class="mr-m" src="./images/red_alexa.svg" alt="red-amazon-alexa" />
	<div>
		<Text class="text-bold text-small"
			>{$format('section_heading_alexa_virtual_actions', {
				default: 'Alexa Virtual Actions',
			})}</Text
		>
		<Text class="text-color-muted text-small"
			>{$format('section_text_alexa_virtual_actions', {
				default:
					'Custom voice commands and routines set up with Alexa will no longer be available.',
			})}
		</Text>
	</div>
</div>
<hr class="mt-s mb-s hr-muted" />
<div class="d-flex align-items-center">
	<img class="mr-m" src="./images/red_dashboard.svg" alt="red-dashboard" />
	<div>
		<Text class="text-bold text-small"
			>{$format('section_heading_extra_dashboards', {
				default: 'Extra Dashboards',
			})}</Text
		>
		<Text class="text-color-muted text-small"
			>{$format('section_text_extra_dashboards', {
				default:
					'You’ll lose access to the content of any additional dashboards you have created to organize and manage your smart devices.',
			})}
		</Text>
	</div>
</div>
<hr class="mt-s mb-s hr-muted" />
<div class="d-flex align-items-center">
	<img class="mr-m" src="./images/red_widgets.svg" alt="red-widgets" />
	<div>
		<Text class="text-bold text-small"
			>{$format('section_heading_custom_additional_widgets', {
				default: 'Custom Additional Widgets',
			})}</Text
		>
		<Text class="text-color-muted text-small"
			>{$format('section_text_custom_additional_widgets', {
				default: 'Enhanced and custom widgets you’ve added to your interface will be disabled.',
			})}
		</Text>
	</div>
</div>
